/* eslint-disable arrow-body-style */
/* eslint-disable newline-before-return */
export const isPrimitive = (
  v: unknown,
): v is string | number | boolean | null => {
  return (
    typeof v === "string" ||
    typeof v === "number" ||
    typeof v === "boolean" ||
    v === null
  );
};

export const isSelectType = (t: string | undefined): boolean => {
  const s = String(t ?? "").toLowerCase();
  return s === "select" || s === "radiobox";
};
